import { render, staticRenderFns } from "./collection-case.vue?vue&type=template&id=08282b92"
import script from "./collection-case.vue?vue&type=script&lang=ts"
export * from "./collection-case.vue?vue&type=script&lang=ts"
import style0 from "./collection-case.vue?vue&type=style&index=0&id=08282b92&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports